import { useQuery } from "@tanstack/react-query";
// API
import API from "./Api";

export const fetchExpiredOrders = async () => {
  const res = await API.get("api/taxi-orders/expired-unresolved");
  return res.data;
};

export default function useGetExpiredUnresolvedOrdersApi() {
  return useQuery({
    queryKey: ["ExpiredOrders"],
    queryFn: () => fetchExpiredOrders(),
  });
}
